module.exports={
  "_args": [
    [
      "stack-chain@^1.3.5",
      "/Users/charlesrudolph/github/cucumber-js"
    ]
  ],
  "_from": "stack-chain@>=1.3.5 <2.0.0",
  "_id": "stack-chain@1.3.7",
  "_inCache": true,
  "_installable": true,
  "_location": "/stack-chain",
  "_nodeVersion": "5.7.1",
  "_npmOperationalInternal": {
    "host": "packages-13-west.internal.npmjs.com",
    "tmp": "tmp/stack-chain-1.3.7.tgz_1457964892201_0.46984840696677566"
  },
  "_npmUser": {
    "email": "amwebdk@gmail.com",
    "name": "andreasmadsen"
  },
  "_npmVersion": "3.6.0",
  "_phantomChildren": {},
  "_requested": {
    "name": "stack-chain",
    "raw": "stack-chain@^1.3.5",
    "rawSpec": "^1.3.5",
    "scope": null,
    "spec": ">=1.3.5 <2.0.0",
    "type": "range"
  },
  "_requiredBy": [
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/stack-chain/-/stack-chain-1.3.7.tgz",
  "_shasum": "d192c9ff4ea6a22c94c4dd459171e3f00cea1285",
  "_shrinkwrap": null,
  "_spec": "stack-chain@^1.3.5",
  "_where": "/Users/charlesrudolph/github/cucumber-js",
  "author": {
    "email": "amwebdk@gmail.com",
    "name": "Andreas Madsen"
  },
  "bugs": {
    "url": "https://github.com/AndreasMadsen/stack-chain/issues"
  },
  "dependencies": {},
  "description": "API for combining call site modifiers",
  "devDependencies": {
    "tap": "2.x.x",
    "uglify-js": "2.5.x"
  },
  "directories": {},
  "dist": {
    "shasum": "d192c9ff4ea6a22c94c4dd459171e3f00cea1285",
    "tarball": "http://registry.npmjs.org/stack-chain/-/stack-chain-1.3.7.tgz"
  },
  "gitHead": "2445f95c5ffdfc9da36703da1be236745bb4a26e",
  "homepage": "https://github.com/AndreasMadsen/stack-chain#readme",
  "keywords": [
    "stack",
    "chain",
    "trace",
    "call site",
    "concat",
    "format"
  ],
  "license": "MIT",
  "maintainers": [
    {
      "email": "amwebdk@gmail.com",
      "name": "andreasmadsen"
    }
  ],
  "name": "stack-chain",
  "optionalDependencies": {},
  "readme": "ERROR: No README data found!",
  "repository": {
    "type": "git",
    "url": "git://github.com/AndreasMadsen/stack-chain.git"
  },
  "scripts": {
    "test": "tap ./test/simple"
  },
  "version": "1.3.7"
}
